import { z } from 'zod'

export const communityProfileUpdateSchema = z.object({
  business_name: z.string().optional(),
  sector: z.string().optional(),
  location: z.string().optional(),
  description: z.string().max(500).optional(),
  website_url: z.string().url().optional(),
  visible: z.number().int().min(0).max(1).optional(),
})

export const recommendationCreateSchema = z.object({
  business_name: z.string().min(1, 'Business name is required'),
  category: z.string().min(1, 'Category is required'),
  contact_phone: z.string().optional(),
  contact_email: z.string().email().optional(),
  contact_website: z.string().url().optional(),
  reach_type: z.enum(['local', 'regional', 'national', 'international']),
  region: z.string().optional(),
})

export const endorsementCreateSchema = z.object({
  recommendation_id: z.number().int().positive(),
  testimonial: z.string().min(1, 'Testimonial is required').max(1000),
})

export const perkCreateSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().min(1, 'Description is required'),
  conditions: z.string().optional(),
  expires_at: z.string().datetime().optional(),
})
